<template>
  <div class="container mx-auto flex flex-col text-5xl">
    Loading...
  </div>
</template>

<script>
export default {
  name: 'Loading',
};
</script>
